export const FMCG_META_DESCRIPTION_BG =
  "Медиен мониторинг и медийни анализи за FMCG брандове в Югоизточна Европа - кампании, конкуренти, потребителски нагласи, съставки и анализ на репутацията.";
